export const FETCH_HUBBLOG = "app/HubBlog/FETCH_HUBBLOG";
export const FETCH_HUBBLOG_SUCCESS = "app/HubBlog/FETCH_HUBBLOG_SUCCESS";
export const FETCH_HUBBLOG_FAILURE = "app/HubBlog/FETCH_HUBBLOG_FAILURE";

// ADD
export const ADD_HUBBLOG = "app/HubBlog/ADD_HUBBLOG";
export const ADD_HUBBLOG_SUCCESS = "app/HubBlog/ADD_HUBBLOG_SUCCESS";
export const ADD_HUBBLOG_FAILURE = "app/HubBlog/ADD_HUBBLOG_FAILURE";

// EDIT
export const EDIT_HUBBLOG = "app/HubBlog/EDIT_HUBBLOG";
export const EDIT_HUBBLOG_SUCCESS = "app/HubBlog/EDIT_HUBBLOG_SUCCESS";
export const EDIT_HUBBLOG_FAILURE = "app/HubBlog/EDIT_HUBBLOG_FAILURE";

// DELETE
export const DELETE_HUBBLOG = "app/HubBlog/DELETE_HUBBLOG";
export const DELETE_HUBBLOG_SUCCESS = "app/HubBlog/DELETE_HUBBLOG_SUCCESS";
export const DELETE_HUBBLOG_FAILURE = "app/HubBlog/DELETE_HUBBLOG_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/HubBlog/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/HubBlog/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/HubBlog/GET_VIEW_DATA_FAILURE";

// GET VIEW DATA
export const UPLOAD_MEDIA = "app/HubBlog/UPLOAD_MEDIA";
export const UPLOAD_MEDIA_SUCCESS = "app/HubBlog/UPLOAD_MEDIA_SUCCESS";
export const UPLOAD_MEDIA_FAILURE = "app/HubBlog/UPLOAD_MEDIA_FAILURE";
